<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <br>
          <br>
          <div class="card " v-if="$gate.isAdmin()">
            <div class="card-header">
              <h4 class="card-title">Статистика по сотрудникам <b></b></h4><br><br>
              <div class="row">
                <div class="col">
                <label for="start_date">Начальная дата:</label>
                <input type="date" id="start_date" v-model="startDate" />
                </div>
                <div class="col">
                <label for="end_date">Конечная дата:</label>
                <input type="date" id="end_date" v-model="endDate"  />
                </div>
                <div class="col">
                <button @click="getResults">   <i class="fa fa-search "></i> Получить данные</button>
              </div>
              </div>
						</div>
            <!-- /.card-header -->
            <div class="card-body table-responsive p-0">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>Сотрудник</th>
                  <th>Количество заказов</th>
                  <th>Общая сумма</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="order in orders" :key="order.name">
                  <td>{{ order.name }} {{ order.family }} {{ order.surname }}</td>
                  <td>{{ order.total_orders }}</td>
                  <td>{{ order.total_amount }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- /.card-body -->
            <div class="card-footer">
              <pagination :data="values" @pagination-change-page="getResults" :limit="5">
                <span slot="prev-nav">&lt; Назад</span>
                <span slot="next-nav">Вперед &gt;</span>
              </pagination>
            </div>
          </div>
          <!-- /.card -->
        </div>
      </div>

      <div v-if="!$gate.isAdmin()">
        <not-found></not-found>
      </div>
      <!-- Modal -->
    </div>
  </section>
</template>

<script>
import SearchWidget from "../widgets/SearchWidget";
export default {
  components: {SearchWidget},
  props: [
    'id',
    // 'close'
  ],
  data() {
    return {
      editmode: false,
      modalDialogState: false,
      values: {},
      sort: {
        id: 'ASC',
        login: 'ASC',
        created_at: 'ASC',
        status: 'ASC',
      },
      startDate: this.getStartOfMonth(),
      endDate: this.getEndOfMonth(),
      orders: [],
      urls: {
        getdata: "/api/orders-by-period",
      },
    }
  },
  methods: {
    searchWid(){
      this.$refs.search.data(this.search);
    },
    toastError(errors){
      if (errors && errors.length == 1){
        Toast.fire({
          timer: 5000,
          icon: 'error',
          title: errors
        })
      }else{
        var result = Object.keys(errors).map((key) => [errors[key]]);
        for (var i = 0; i < result.length; i++){
          Toast.fire({
            timer: 5000,
            icon: 'error',
            title: result[i][0][0]
          })
        }
      }
    },
    validateErrors(errors){
      if(errors.response &&  errors.response.status==401){
        var error=[];
        error[0]='Истекло время сессии, войдите повторно';
        this.toastError(error);
        window.location.href = "login";
      }
      this.toastError(errors.response.data.errors);
    },
    getStartOfMonth() {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];
    },
    // Метод для получения конца текущего месяца
    getEndOfMonth() {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().split('T')[0];
    },
    async getResults() {
      this.$Progress.start();
      axios.get(this.urls.getdata , {
        params: {
          start_date: this.startDate,
          end_date: this.endDate
        }
      })
          .then(({data}) => (
              this.orders = data
          ))
          .catch((errors) => {
            this.toastError(errors.response.data.errors);
          });

      this.$Progress.finish();
    },
  },
  mounted() {
    this.$Progress.start();
    this.getResults();
    this.$Progress.finish();

  },
}
</script>

<style>
.search_form {
  font-size: 16px;
  background: #FFF;
  /*border: 1px #ccc solid;*/
  width: auto;
  border-radius: 4px;
  max-height: 30em;
  overflow-y: scroll;
  /*margin-left: -2em;*/
}
.search_form li:hover {
  background: #368fdb;
  color: white;
}
.table-hover  th::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 5px;
  right: 5px;
  height: 3px;
  //background: #ffcc99;
}
.swal2-container {
    z-index: 9999;
}
/*.vs--searchable .vs__dropdown-toggle {*/
/*  width: 13em;*/
/*}*/
</style>
